import {getPreference} from '@netx/core-user-next/utils/getPreference';
import {currentUserMeetsUserLevel} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {AdBuilderPref, AD_BUILDER_MINIMUM_USER_LEVEL} from './constants';

export const adBuilderEnabled = () =>
	getPreference(AdBuilderPref.ENABLED, true);

export const canManageAdBuilder = () =>
	currentUserMeetsUserLevel(AD_BUILDER_MINIMUM_USER_LEVEL);
